import clsx from "clsx"
import { forwardRef } from "react"
import ArrowIcon from "@/assets/icons/triangle-02.webp"
import "@/assets/css/select.css"

const Select = forwardRef(({ required = false, name, id, label, custCls, custLabelCls, errMsg = "", optionName, optionVal, isSelect2 = false, borderColor, forProduct = false, showEmptyOption = false, noLabel = false, disabled = false, options = [], onInputSelect = () => { } }, ref) => {
  const onInputVal = (e) => {
    onInputSelect(e.target.value)
  }

  return (
    <>
      {!noLabel && (
        <label className={clsx("font-agcasmlt font-light text-[#6d625a] inline-block text-base sm:text-lg", custLabelCls)}>{label}</label>
      )}
      <div className="relative z-10">
        {/* pt-2 px-2 */}
        <select defaultValue="" disabled={disabled} onInput={onInputVal} required={required} name={name} id={id} className={clsx("border-[1.5px] border-[#6d625a] font-agcasmlt text-base font-light pt-2 px-2 focus:outline-none w-full bg-transparent", { "h-[2.5rem] md:h-[3rem]": forProduct, "h-[2.15rem]": !isSelect2 && !forProduct, "h-10 pb-1": isSelect2 && !forProduct, "bg-transparent": !disabled, "!bg-light-gray cursor-not-allowed": disabled }, borderColor)} {...ref}>
          {(!required || showEmptyOption) && (
            <option value="" disabled className="text-base"></option>
          )}
          {options.map((o, i) => (
            optionVal && optionName ?
              <option key={i} className="text-base" value={o[optionVal]}>{o[optionName]}</option>
              :
              <option key={i} className="text-base" value={o}>{o}</option>
          ))}
        </select>
        {errMsg && (
          <span className="text-[10px] sm:text-[12px] text-red-600">{errMsg}</span>
        )}
        <span className="absolute right-1 -top-1 -z-10">
          <button type="button">
            <img width="10" src={ArrowIcon} />
          </button>
        </span>
      </div>
    </>
  )
})

export default Select